import {
  fetchGetOpenBankingShareableLinkHandler,
  GetOpenBankingShareableLinkHandlerResponse,
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

export function useGetOpenBankingShareableLink({ token }: { token?: string }) {
  const {
    data: response,
    isLoading,
    isError,
  } = useQuery<GetOpenBankingShareableLinkHandlerResponse>({
    queryKey: ['getOpeningBankingShareableLink', token],
    queryFn: () => fetchGetOpenBankingShareableLinkHandler({ token: token! }),
    enabled: Boolean(token),
  });

  return { openBankingLink: response?.data, isLoading, isError };
}
